module.exports = __webpack_public_path__ + "assets/smart-asset-canvasux-icon.69f78d54.svg";